import React, { useEffect } from "react";
import CountUp from "react-countup";
import AOS from "aos";

const FunFact = (props) => {
  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 1000,
      easing: "ease-in-sine",
      delay: 100,
      once: true,
    });
  }, []);
  return (
    <section className={"" + props.hclass}>
      <div className="container">
        <div className="row" data-aos="fade-down">
          <div className="col col-lg-3 col-md-6 col-12">
            <div className="item">
              <h3>
                <span>
                  <CountUp end={13} enableScrollSpy />
                </span>
                +
              </h3>
              <h4>Produk Unggulan</h4>
            </div>
          </div>
          <div className="col col-lg-3 col-md-6 col-12">
            <div className="item">
              <h3>
                <span>
                  <CountUp end={9} enableScrollSpy />
                </span>
                +
              </h3>
              <h4>Dipercaya Client</h4>
            </div>
          </div>
          <div className="col col-lg-3 col-md-6 col-12">
            <div className="item">
              <h3>
                <span>
                  <CountUp end={6} enableScrollSpy />
                </span>
                +
              </h3>
              <h4>Memiliki Layanan</h4>
            </div>
          </div>
          <div className="col col-lg-3 col-md-6 col-12">
            <div className="item">
              <h3>
                <span>
                  <CountUp end={3} enableScrollSpy />
                </span>
                +
              </h3>
              <h4>Produk Ditawarkan</h4>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FunFact;
